export default __webpack_public_path__ + "static/media/accc.240a9c4f.png";